import axios from "axios";
import { get } from "../http/platformServer";
import { ExtendAxiosRequestConfig } from "../http/types";
import { Base64 } from "js-base64";

export interface MCToken {
    token: string;
    /** 到期时间 */
    expireIn: number;
}

/** 获取抖店Token */
export function getMcToken(shopId: number, config?: ExtendAxiosRequestConfig) {
    return get<MCToken>(shopId, `/jinritemai/order/security/get_mc_token`, { shopId }, config);
}

export interface EncryptMcToken {
    /**
     * 已经使用AES加密的token
     */
    token: string;
    /** 到期时间 */
    expireIn: number;
}

/**
 * 获取抖店Token
 *
 * 请求链接没有弄错，是故意命名的
 */
export function getEncryptMcToken(shopId: number, config?: ExtendAxiosRequestConfig) {
    return get<MCToken>(shopId, `/picking_label/get_label_value`, { shopId }, config);
}

interface DDBuyerNicknameResponse {
    code: number;
    /**
     * base64编码后的数据
     */
    data: string;
}

const nicknameCache = new Map<string, string>();

/**
 * 获取抖店买家昵称
 */
export async function getDDBuyerNickname(token: string, orderId: string) {
    // 优先从缓存中获取
    if (nicknameCache.has(orderId)) {
        return nicknameCache.get(orderId)!;
    }

    const response = await axios.post<DDBuyerNicknameResponse>("https://edbc.fahuoyi.com/get_label_value", {
        token,
        orderId,
    });

    const data = response.data;

    if (data?.code === 0 && data?.data) {
        const decoded = Base64.decode(data.data);
        // 成功获取后存入缓存
        nicknameCache.set(orderId, decoded);
        return decoded;
    }

    return "***";
}

const CACHE_KEY = "__DD_GET_LABEL_VALUE_TOKEN__";

/**
 * 确保获取到抖店Token
 */
export async function ensureEncryptMcToken(shopId: number) {
    const key = `${CACHE_KEY}_${shopId}`;
    // 尝试读取缓存
    try {
        const cachedData = localStorage.getItem(key);

        if (cachedData) {
            const { token, expireIn } = JSON.parse(cachedData);

            if (expireIn > Date.now()) {
                return token as string; // 返回有效缓存
            }
        }
    } catch (error) {
        localStorage.removeItem(key); // 清除无效缓存
    }

    // 缓存无效时请求新 token
    const data = await getEncryptMcToken(shopId);

    localStorage.setItem(key, JSON.stringify(data));

    return data.token;
}
